<template lang="pug">
h4.title-letter.text-large
  slot
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'

/**
 * 題字タイトル(h4要素)
 */
@Component
export default class TitleLetter extends Vue {}
</script>

<style lang="stylus" scoped></style>
